// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\npicture>img {\n  width: 100px;\n}\n.worst {\n  background: red;\n  color: white;\n}\n.best {\n  background: green;\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
